import { parse as parseMathExpression } from "mathjs";
import { IOtherAttributesMathFormula } from "@schemas/otherAttributesSchema";

export const MATH_FORMULA_EXAMPLES = [
  "A - B",
  "(A / B) * 100",
  "round(C * 1.25, 2)",
];

export const getMathFormulaVariableNames = (expression: string): string[] => {
  const parsedExpression = parseMathExpression(expression);
  const variableNames = new Set<string>();

  parsedExpression.traverse((node, path, parent) => {
    if (!("isSymbolNode" in node) || node.isSymbolNode !== true) {
      return;
    }

    if (parent && "isFunctionNode" in parent && parent.isFunctionNode === true && path === "fn") {
      return;
    }

    variableNames.add((node as unknown as { name: string }).name);
  });

  return Array.from(variableNames);
};

export const validateMathFormulaExpression = (expression: string, allowedVariables: string[]): string | null => {
  if (!expression.trim()) {
    return "Formelen kan ikke være tom.";
  }

  try {
    const usedVariables = getMathFormulaVariableNames(expression);
    const invalidVariables = usedVariables.filter((variableName) => !allowedVariables.includes(variableName));

    if (invalidVariables.length > 0) {
      return `Kun støttede attributt-IDer kan brukes i formelen. Ugyldige felter: ${invalidVariables.join(", ")}`;
    }

    return null;
  } catch {
    return "Ugyldig formel.";
  }
};

export const buildMathFormula = ({
  expression,
  variables,
}: {
  expression: string;
  variables: string[];
}): IOtherAttributesMathFormula => ({
  expression,
  variables,
});
